import React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { RoiReportingPage } from './main/RoiReportingPage';

export const ROIReports = () => (
  <>
    <DocumentHead title='ROI Report' />
    <PageTemplate main={<RoiReportingPage />} />
  </>
);
